module.exports = __webpack_public_path__ + "img/TECATE-NEON-ROJO.36ddcc25.png";